import { iconOverrides } from "ag-grid-community";

import { iconDataUrl } from "../../icons/iconMarkup.ts";

/** Masked, unlike the grid's other icon overrides, so a checked menu option's tick takes its text colour. */
export const menuCheckIconPart = iconOverrides({
  type: "image",
  mask: true,
  icons: { tick: { url: iconDataUrl("phosphor/check") } },
});
